import ConfigurationUseCasesInterface from "./configurationInterface";
import { Configuration } from "../../../entities/configuration";
import configurationRepository from "../../../../infrastructure/repository/impl/configuration/configuration_repository";

class ConfigurationUseCases implements ConfigurationUseCasesInterface {
  async get(): Promise<Configuration> {
    return await configurationRepository.get();
  }
}

export default new ConfigurationUseCases() as ConfigurationUseCasesInterface;
